import React from "react";
import type { LucideIcon } from "lucide-react";

export type ButtonVariant = "fill" | "update" | "outline" | "secondary-outline" | "delete-outline" | "delete-soft" | "update-outline" | "active-outline" | "inactive-outline" | "success" | "danger";

interface ButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  variant?: ButtonVariant;
  icon?: LucideIcon;
  type?: "button" | "submit" | "reset";
  form?: string;
  /** Optional. Omit (along with passing only `icon`) to render an icon-only square button.
   *  Provide an `aria-label` when iconOnly for accessibility. */
  children?: React.ReactNode;
}

const variantClasses: Record<ButtonVariant, string> = {
  fill: "btn-primary-fill",
  update: "btn-primary-update",
  outline: "btn-primary-outline",
  "secondary-outline": "btn-secondary-outline",
  "delete-outline": "btn-delete-outline",
  "delete-soft": "btn-delete-soft",
  "update-outline": "btn-update-outline",
  "active-outline": "btn-active-outline",
  "inactive-outline": "btn-inactive-outline",
  "success": "btn-success",
  "danger": "btn-danger",
};

const Button: React.FC<ButtonProps> = ({
  variant = "fill",
  icon: Icon,
  type = "button",
  form,
  children,
  className = "",
  ...rest
}) => {
  const iconOnly = !children && !!Icon;
  return (
    <button
      type={type}
      form={form}
      className={`${variantClasses[variant]} ${iconOnly ? "btn-icon-only" : ""} ${className}`.trim()}
      {...rest}
    >
      {Icon && <Icon size={14} />}
      {children}
    </button>
  );
};

export default Button;
